import jquery from 'admin-lte/plugins/jQuery/jquery-2.2.3.min';
window.$ = window.jQuery = global.jQuery = jquery;



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/style/jqueryConfig.js